import { API, setAuthToken } from '../../../config/API.js';
import { GET_PROMOSI, SET_LOADING_PROMOSI, SET_PAGINATION_PROMOSI } from '../constant.js';

export const getPromosi = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_PROMOSI,
      payload: true,
    });
    API.get(`admin/promotion?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_PROMOSI,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_PROMOSI,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_PROMOSI,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_PROMOSI,
          payload: 0,
        });
      });
  };
};

export const addPromosi = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/promotion/add", params);
};

export const getDetailPromosi = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/promotion/" + id);
};

export const updPromosi = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/promotion/edit", params);
};

export const delPromosi = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/promotion/delete/" + code);
};
